import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import { CheckCircle2, XCircle } from 'lucide-react'

// Define um tipo para o tipo de mensagem
type MessageType = 'success' | 'error'

// Define a estrutura do objeto de mensagem
interface Message {
  type: MessageType
  text: string
}

// Props que nosso componente vai receber
interface FeedbackDialogProps {
  isOpen: boolean
  onOpenChange: (value: boolean) => void
  message: Message | null
}

export function FeedbackDialog({ isOpen, onOpenChange, message }: FeedbackDialogProps) {
  if (!isOpen || !message) return null

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{message?.type === 'success' ? 'Sucesso' : 'Erro'}</DialogTitle>
          <DialogDescription className="flex items-center space-x-2">
            {message?.type === 'success' ? (
              <CheckCircle2 className="h-6 w-6 text-green-500" />
            ) : (
              <XCircle className="h-6 w-6 text-red-500" />
            )}
            <span>{message?.text}</span>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
